import React, { useCallback, useEffect, useState } from "react";
import AppShell from "../../components/AppShell";
import { api } from "../../lib/api";
import { Alert, btn } from "../../components/workforce/common";
import IntegrationErrorHistory from "../../components/comms/IntegrationErrorHistory";

const msg = (e) => e?.response?.data?.detail?.message || "Something went wrong.";

// B12: failed / blocked / suppressed deliveries with reasons. Retry only for temporary provider errors.
export default function DeliveryRecovery() {
  const [rows, setRows] = useState([]);
  const [m365, setM365] = useState(null);
  const [note, setNote] = useState("");
  const load = useCallback(() => api.get("/comms/admin/delivery").then((r) => setRows(r.data)).catch((e) => setNote(msg(e))), []);
  useEffect(() => { load(); api.get("/comms/admin/m365-errors").then((r) => setM365(r.data)).catch(() => {}); }, [load]);
  const retry = (id) => api.post(`/comms/admin/delivery/${id}/retry`).then((r) => { setNote(r.data.note); load(); }).catch((e) => setNote(msg(e)));
  return (
    <AppShell title="Delivery recovery" subtitle="Failed, blocked and suppressed messages">
      <div className="mx-auto w-full max-w-[1100px] px-4 space-y-4" data-testid="dr-page">
        <h1 className="font-heading text-xl">Messages that were not delivered</h1>
        <p className="text-xs">Suppressed (test recipients), blocked and recorded-only messages are never retried. Only temporary provider errors (timeouts, rate limits, provider outages) can be retried.</p>
        <Alert text={note} testid="dr-note" />
        {rows.length === 0 && <p data-testid="dr-empty">Nothing to recover.</p>}
        <ul className="space-y-2">{rows.map((r) => (
          <li key={r.id} className="rounded border border-erf-borderCream bg-white p-3 text-sm flex flex-wrap items-center gap-2" data-testid={`dr-row-${r.id}`}>
            <span className="mr-auto"><strong>{r.subject || r.kind}</strong> → {r.to} · <span data-testid={`dr-state-${r.id}`}>{r.state.replace(/_/g, " ")}</span> · {r.reason}</span>
            {r.retryable ? <button type="button" className={btn} onClick={() => retry(r.id)} data-testid={`dr-retry-${r.id}`}>Retry</button>
              : <span className="text-xs" data-testid={`dr-noretry-${r.id}`}>Not retryable ({r.retry_rule.replace(/_/g, " ")})</span>}
          </li>))}</ul>
        {m365 && (
          <section className="space-y-1" data-testid="dr-m365">
            <h2 className="font-heading text-lg">Microsoft 365 sync</h2>
            <p className="text-sm font-semibold">{m365.label}</p>
            {m365.errors.length === 0 ? <p className="text-sm">No sync errors recorded.</p>
              : <ul className="text-sm">{m365.errors.map((x, i) => <li key={i} data-testid={`dr-m365-${i}`}>{(x.at || "").slice(0, 16).replace("T", " ")} · {x.action}</li>)}</ul>}
          </section>)}
        <IntegrationErrorHistory />
      </div>
    </AppShell>
  );
}
